import React from 'react';

import { useCountsDays } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanSettings';
import { usePlanStateField } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { BUDGET } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';
import { precision } from 'scenes/MarketingPlanning/utils';

import { HighLightTextField } from './components';

export const BudgetAmount = props => {
  const { value, onChange, resolvedName } = usePlanStateField(BUDGET);
  return (
    <HighLightTextField
      value={value}
      onChange={onChange}
      path={resolvedName}
      type={'currency'}
      placeholder={'$0'}
      width={'108px'}
      {...props}
    />
  );
};

export const BudgetPercent = props => {
  const { onChange, resolvedName } = usePlanStateField(BUDGET);
  const { budgetParent, budgetPercent } = useViewStateByResolveName();

  const handleChange = React.useCallback(
    (e, value = 0) => {
      onChange(e, precision(budgetParent * (value * 0.01)));
    },
    [budgetParent]
  );

  return (
    <HighLightTextField
      value={budgetPercent}
      onChange={handleChange}
      path={resolvedName}
      type={'percent'}
      placeholder={'0%'}
      width={'58px'}
      {...props}
    />
  );
};

export const BudgetDaily = props => {
  const { onChange, resolvedName } = usePlanStateField(BUDGET);
  const { budgetDaily } = useViewStateByResolveName();
  const countDays = useCountsDays();

  const handleChange = React.useCallback(
    (e, value = 0) => {
      onChange(e, precision(countDays * value));
    },
    [countDays]
  );

  return (
    <HighLightTextField
      value={budgetDaily}
      onChange={handleChange}
      path={resolvedName}
      type={'currency'}
      placeholder={'$0'}
      width={'91px'}
      {...props}
    />
  );
};
